<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <v-icon icon="flag" :title="t('component.iconIssue.title')" />
</template>

<style scoped lang="scss"></style>
